export const objectToString = target => {
  let result = ""
  Object.keys(target).forEach(key => {
    if (result === "") {
      // just starting add?
      result += "?"
    } else {
      result += "&"
    }
    const value = target[key]
    result += `${key}=${encodeURIComponent(value)}`
  })
  return result
}
